<template>
  <div class="carts">
    <div>
      <!-- 顶部导航 -->
      <div v-if="denglu!=null && goods.length != 0" class="nav" style="display: block; padding-bottom: 3.3125rem;">
        <div style="display: flex; justify-content: space-between; width: 100%;">
          <van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
          <span style="    position: absolute; top: -0.125rem; left: 2.625rem; font-size: 1rem;">购物车</span>
          <span @click="isDelete=false" v-if="isDelete">管理</span>
          <span @click="isDelete=true" v-else>完成</span>
        </div>
        <!-- <div style="width: 100%; height: 1rem; margin-top: 0.375rem;">
					<span class="Delivery">配送至：{{defaultAddress.province}}{{defaultAddress.city}}{{defaultAddress.area}}{{defaultAddress.address}}</span>
				</div> -->
      </div>
      <div v-else class="nav">
        <van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
        <span>购物车</span>
        <span @click="isDelete=false" v-if="isDelete">管理</span>
        <span @click="isDelete=true" v-else>完成</span>
      </div>
      <div v-if="denglu!=null  && goods.length != 0" style="margin-top: 1.25rem; background-color: #F1452F;">
        <div class="tips">
          <div>
            <van-icon size="0.9rem" name="passed" />
            <span>正品保证</span>
          </div>
          <div>
            <van-icon size="0.9rem" name="passed" />
            <span>厂家直发</span>
          </div>
          <div>
            <van-icon size="0.9rem" name="passed" />
            <span>全新定制</span>
          </div>
          <div>
            <van-icon size="0.9rem" name="passed" />
            <span>全国联保</span>
          </div>
        </div>
      </div>
      <div class="wares" v-if="goods.length != 0">
        <div class="main">
          <div class="backgd"></div>
          <div class="list" v-if="goods.cart != undefined">
            <div class="list_msg" v-for="(item,index) in goods.cart">
              <van-checkbox v-model="item.ischeck" checked-color="#f1452f" icon-size="1rem"
                @click="chooseChange(item.id)"></van-checkbox>
              <van-card>
                <div slot="thumb" class="van-image" @click="goDetail(item.goods_id)">
                  <img :src="item.image | handleUrl" alt="">
                </div>
                <div slot="title" class="van_title">
                  <span>{{item.title}}</span>
                </div>
                <div slot="desc" class="van_desc">
                  <div>{{item.goods_spec_combination.goods_spec_name}}</div>
                  <div v-if="item.lease == null"></div>
                  <div style="margin-top: 0.2rem;" v-else>{{item.lease.title}}</div>
                </div>
                <div slot="desc" class="van_title"
                  style="display: flex; justify-content: space-between; margin-top: 0.5rem;">
                  <div v-if="item.lease_id == 7">
                    <span class="active">月支付租金¥{{item.goods_spec.data.Lease_algorithm_price}}</span>
                  </div>
                  <div v-if="item.lease_id == 4">
                    <span class="active">首年月租金¥{{item.goods_spec.data.Lease_algorithm_price}}</span>
                  </div>
                  <div v-if="item.lease_id == 6">
                    <span class="active">买断金额¥{{item.goods_spec.data.total}}</span>
                  </div>
                  <van-stepper button-size="1.1rem" @minus="update(index,item.id,0)" @plus="update(index,item.id,1)"
                    input-width="1.5rem" v-model="item.cart_num" />
                </div>
              </van-card>
            </div>
          </div>
          <div class="list" v-if="goods.overdue != undefined">
            <div class="list-distory">已失效的宝贝</div>
            <div class="list_msg" v-for="(item,index) in goods.overdue">
              <div class="list-msg-distory"></div>
              <van-card :thumb="item.goods.image | handleUrl">
                <div slot="title" class="van_title">
                  <span>{{item.goods.title}}</span>
                </div>
                <div slot="price" class="list-msg-lose">
                  <div @click="clearB(item.id)">删除</div>
                  <div>已失效</div>
                </div>
              </van-card>
            </div>
          </div>
          <div class="foot">
            <span class="title">-猜-你-喜-欢-</span>
            <Like></Like>
          </div>
        </div>
        <!-- 结算栏 -->
        <div class="settle">
          <div style="display: flex; justify-content: space-between;">
            <div class="all">
              <van-checkbox v-model="AllChecked" @click="checkAll" checked-color="#f1452f" icon-size="1rem">
              </van-checkbox>
              <span style="line-height: 1.75rem;">全选</span>
            </div>
            <div v-if="isDelete" class="settle_btn">
              <span v-if="goods.cart[0].lease_id == 7">需支付首年租金</span>
              <span v-if="goods.cart[0].lease_id == 4">需支付首月租金</span>
              <span v-if="goods.cart[0].lease_id == 6">需支付买断金额总计</span>
              <span class="totals">¥{{sum().toFixed(1)}} </span>
              <span
                style="color: #fff; font-size: 0.9rem; background-color: #F1452F; padding: 0.2rem 0.4rem; border-radius: 999px;"
                @click="orderPay">去结算({{selectedData.length}})</span>
            </div>
            <div v-else>
              <van-button type="default" size="mini" round @click="clear" class="shanchubu">删除</van-button>
            </div>
          </div>
          <div v-if="goods.cart[0].lease_id == 6">
            <div style="text-align: right; color: #999;">市场购买参考含税价¥{{sum1().toFixed(1)}},为您节省￥<span style="color: #7dcd7c;">{{(sum1()-sum()).toFixed(1)}}</span></div>
          </div>
          <div v-if="goods.cart[0].lease_id == 7">
            <div style="color: #999; text-align: right;">市场购买参考含税价¥{{sum1().toFixed(1)}},为您节省￥<span style="color: #7dcd7c;">{{(sum1()-sum()).toFixed(1)}}</span></div>
          </div>
          <div v-if="goods.cart[0].lease_id == 4">
            <div style="color: #999; text-align: right;">市场购买参考含税价¥{{sum1().toFixed(1)}},为您节省￥<span style="color: #7dcd7c;">{{(sum1()-sum()).toFixed(1)}}</span></div>
          </div>
        </div>
        <div>

        </div>
      </div>
    </div>
    <!-- 购物车没有订单 -->
    <div class="cart-nud" v-if="goods.length === 0">
      <div class="head">
        <!-- 顶部导航 -->
        <div class="nav">
          <router-link to="/home">
            <van-icon name="arrow-left" color="#fff" size="1.2rem" />
          </router-link>
          <span>购物车</span>
          <div></div>
        </div>
      </div>
      <!-- 提示信息 -->
      <div class="msg">

        <div class="top">
          <img src="../../assets/cart.png" alt="">
          <van-button type="default" size="mini" round to="/Home">去逛逛吧</van-button>
        </div>
        <div class="foot">
          <span class="title">-猜-你-喜-欢-</span>
          <Like></Like>
        </div>
      </div>
    </div>
    <cartBar></cartBar>
  </div>
</template>

<script>
  import cartBar from '@/components/cartBar'
  import Like from '@/components/like/like'

  export default {
    inject: ['reload'],
    data() {
      return {
        AllChecked: false, //全选
        isDelete: true,
        value: 1,
        goods: [],
        //选中待结算商品
        selectedData: [],
        result: [],
        defaultAddress: '',
        denglu: '',
        yueshu: ''
      }
    },
    components: {
      cartBar,
      Like
    },
    created() {
      this.clear();
      this.getcart();
      this.denglu = localStorage.getItem('Authorization')
      // 获取用户地址
      this.$axios.post(baseUrl + '/mobile/User/userAddressStatus', {
        token: localStorage.getItem('Authorization')
      }).then((res) => {
        if (res.data.code == 2) {
          this.defaultAddress = res.data.data
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    methods: {
      getcart() {
        this.$axios.post(baseUrl + '/mobile/Cart/cart', {
          token: localStorage.getItem('Authorization')
        }).then((res) => {
          if (res.data.code == 2) {
            for (var i = 0; i < res.data.data.cart.length; i++) {
              res.data.data.cart[i].ischeck = false;
            }
            this.goods = res.data.data;
            this.yueshu = parseFloat(this.goods.cart[0].lease.title) / 2
            console.log(this.yueshu)
          }
        }).catch((err) => {
          console.log(err);
        })
      },
      // 单选的change事件
      chooseChange(id) {
        if (this.selectedData.indexOf(id) > -1) {
          this.selectedData.splice(this.selectedData.indexOf(id), 1);
        } else {
          this.selectedData.push(id);
        }
        if (this.selectedData.length < this.goods.cart.length) {
          this.AllChecked = false;
        } else {
          this.AllChecked = true;
        }
      },
      // 全选和反选
      checkAll() {
        for (var i = 0; i < this.goods.cart.length; i++) {
          let list = this.goods.cart[i];
          if (this.AllChecked) {
            list.ischeck = false;
            this.selectedData = [];
          } else {
            list.ischeck = true;
            if (this.selectedData.indexOf(list.id) < 0) {
              this.selectedData.push(list.id);
            }
          }
        }
      },
      //遍历数组,计算总金额
      sum: function() {
        var s = 0;
        for (var i = 0; i < this.goods.cart.length; i++) {
          if (this.goods.cart[i].ischeck == true) {
            s += this.goods.cart[i].goods_spec.data.total * this.goods.cart[i].cart_num;
          }
        };
        return s;
      },
      sum1: function() {
        var s = 0;
        for (var i = 0; i < this.goods.cart.length; i++) {
          if (this.goods.cart[i].ischeck == true) {
            s += this.goods.cart[i].goods_spec.data.market_price * this.goods.cart[i].cart_num;
          }
        };
        return s;
      },
      sum2: function() {
        var s = 0;
        for (var i = 0; i < this.goods.cart.length; i++) {
          if (this.goods.cart[i].ischeck == true) {
            s += this.goods.cart[i].goods_spec.data.Lease_algorithm_price * this.goods.cart[i].cart_num;
          }
        };
        return s;
      },
      sum3: function() {
        var s = 0;
        for (var i = 0; i < this.goods.cart.length; i++) {
          if (this.goods.cart[i].ischeck == true) {
            s += this.goods.cart[i].goods_spec.data.Lease_month_price * this.goods.cart[i].cart_num;
          }
        };
        return s;
      },
      //修改数量
      update(idx, id, type) {
        if (type == 1) {
          var num = this.goods.cart[idx].cart_num + 1;
        } else {
          var num = this.goods.cart[idx].cart_num - 1;
        }
        this.$axios.post(baseUrl + '/mobile/Cart/cartUpdate', {
          id: id,
          cart_num: num
        }).then(function(res) {
          if (res.data.code == 7) {}
        }).catch(function(err) {
          console.log(err);
        })
      },
      //结算
      orderPay() {
        let Lease_total = 0;
        if (this.selectedData.length != 0) {
          this.colation(this.selectedData);
        } else {}
      },
      //删除
      clear() {
        var t = this
        if (this.selectedData.length != 0) {
          this.$dialog.confirm({
            message: '您确定要删除吗？'
          }).then(() => {
            this.$axios.post(baseUrl + '/mobile/Cart/cartDelete', {
              id: this.selectedData
            }).then((res) => {
              if (res.data.code == 9) {
                this.$toast(res.data.msg);
                t.getcart();
                location.reload();
              }
            }).catch((err) => {
              console.log(err);
            })
          }).catch(() => {});
        } else {}
      },
      //删除已失效的宝贝
      clearB(ids) {
        var t = this
        this.$dialog.confirm({
          message: '您确定要删除吗？'
        }).then(() => {
          this.$axios.post(baseUrl + '/mobile/Cart/cartDelete', {
            id: ids
          }).then((res) => {
            if (res.data.code == 9) {
              this.$toast(res.data.msg);
              t.getcart();
            }
          }).catch((err) => {
            console.log(err);
          })
        }).catch(() => {});
      },
      //过滤请求
      colation(ids) {
        this.$axios.post(baseUrl + '/mobile/Order/addCartCache', {
          id: ids,
          token: localStorage.getItem('Authorization')
        }).then((res) => {
          if (res.data.code == 19) {
            this.$router.push({
              path: '/pays',
              query: {
                type: 2
              }
            })
          } else {
            this.$toast(res.data.msg);
          }
        }).catch((err) => {
          console.log(err);
        })
      },
      //跳转详情
      goDetail(ids) {
        this.$router.push({
          path: '/Detail',
          query: {
            id: ids
          }
        })
      }
    }
  }
</script>

<style scoped>
  @import "carts.css";

  .van-card__tag {
    top: 0;
  }

  .layer {
    height: 5.5rem !important;
  }

  .like .section .foot-tips i {
    margin-top: 0rem !important;
  }

  .shanchubu {
    color: #ffffff;
    width: 5rem;
    font-weight: bold;
    background: red;
    height: 1.8rem;
  }

  .carts .nav {
    border-bottom: 0px solid #FFFFFF !important;
  }

  .van-card__thumb {
    width: 104px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/carts/carts.vue